<template>
  <ModalTriage v-if="protocolInfo" :visibleModalTriage="isModalTriageVisible" @hideModalTriage="closeModalTriage" :protocolUpdatePopup="protocolInfo"
               :enableButton="false"></ModalTriage>
  <ModalLoadingSignature :visibleModalLoadingSignature="isModalLoadingSignature" :typeSteps="typeSteps"
                         @close="closeModalLoadingSignature" ref="modalLoadingSignature"></ModalLoadingSignature>
  <div class="col-12">
    <div class="my-5">
      <div class="row">
        <div class="col-2">
          <button class="button-back mx-3" v-if="showEditOption" @click="backReport()">
            <img src="../assets/back-button.png" alt="Button Image">
          </button>
        </div>
        <div class="col-8">
          <div>
            <h2 class="fw-bold text-center text-black-50">Tela de revisão</h2>
          </div>

          <div v-if="isLoading === true">
            <div class="container my-5">
              <div class="row mt-5">
                <div class="row mt-4">
                  <div class="col-2"></div>
                  <div class="col-8">
                    <div class="centered-container">
                      <div class="loading"></div>
                    </div>
                    <p class="text-font-regular" style="margin-top: 10px; text-align: center">
                      Carregando...
                    </p>
                  </div>
                  <div class="col-2"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="container-info mt-4">
              <h5 class="fw-bold text-black-50">Paciente:
                {{ formatName(Report.protocol_update_info.protocol_info.patient_info.name) }}</h5>
            </div>

            <h5 class="fw-bold mt-4 text-black-50">Revise as informações abaixo:</h5>

            <div class="container-historical mt-4">
              <div v-for="field in ReportFields" :key="field.id">
                <div v-if="Report[field.name] != null">
                  <div v-if="field.name === 'sedated'">
                    <div v-if="Report[field.name] > 0">
                      <div class="mt-4">
                        <p>{{ field.description }}<strong class="fw-bold"
                                                          style="word-wrap: break-word; text-align: justify;">{{
                            formatRamsay(Report[field.name])
                          }}</strong>
                        </p>
                      </div>
                    </div>
                    <div v-else>
                      <div class="mt-4">
                        <p>{{ field.description }}<strong class="fw-bold"
                                                          style="word-wrap: break-word; text-align: justify;">Não</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="['transference', 'protocol_avc', 'thrombolysis', 'had_teleconsultation', 'patient_present', 'catheterization'].includes(field.name)">
                    <div class="mt-4">
                      <p>{{ field.description }} <strong class="fw-bold"
                                                         style="word-wrap: break-word; text-align: justify;">{{
                          Report[field.name] === 1 ? "Sim" :
                              "Não"
                        }}</strong></p>
                    </div>
                  </div>
                  <div v-else-if="field.name === 'cid_subcategory'">
                    <div class="mt-4">
                      <p>{{ field.description }} <strong class="fw-bold"
                                                         style="word-wrap: break-word; text-align: justify;">{{
                          Report[field.name].description
                        }}</strong></p>
                    </div>
                  </div>
                  <div v-else-if="field.name === 'clinical_documents'">
                    <div class="mt-4" v-for="(clinicalDocument, clinicalDocumentIndex) in Report[field.name]"
                         :key="clinicalDocumentIndex">
                      <p>{{ clinicalDocument.description }}: <strong class="fw-bold"
                                                                     style="word-wrap: break-word; text-align: justify;">{{
                          clinicalDocument.value
                        }}</strong></p>
                    </div>
                  </div>
                  <div v-else>
                    <div class="mt-4">
                      <p>{{ field.description }} <strong class="fw-bold"
                                                         style="word-wrap: break-word; text-align: justify;">{{
                          Report[field.name]
                        }}</strong></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 offset-4">
              <button class="btn btn-success m-4" @click="showModalReportFinished()">Concluir Atendimento</button>
              <button class="btn btn-outline-primary" @click="backReport()" v-if="showEditOption">Editar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalTriage from "../components/ModalTriage.vue";
import ModalLoadingSignature from "../components/ModalLoadingSignature.vue"
import {mapGetters, mapActions} from "vuex";

export default {
  name: `Review`,
  components: {
    ModalTriage: ModalTriage,
    ModalLoadingSignature
  },
  computed: {
    ...mapGetters({
      Report: "StateReport",
      User: "StateUser",
      ReportFields: "StateReportFields"
    }),
  },
  data() {
    return {
      isLoading: true,
      protocolInfo: null,
      showEditOption: true,
      isModalTriageVisible: false,
      isModalLoadingSignature: false,
      diagnosticHypothesisVisible: false,
      typeSteps: ""
    };
  },
  async created() {
    if (!this.isAuthenticated()) {
      this.$router.push("/login");
    } else {
      if (this.Report === null) {
        this.$router.push("/");
      } else {
        try {          
          if (this.Report != null) {
            await this.GetReport(this.Report);
            this.isLoading = false;
          }
        } catch {
          this.$toast.error('Ocorreu um erro, tente novamente.', {
            timeout: 3000,
            closeOnClick: true
          });
        }
      }
    }
  },
  async mounted() {
    try {      
      if (this.Report !== null) {
        await this.GetReportFields(this.Report.protocol_update_info.protocol_info.specialty_id);
      }      
    } catch {
      this.$toast.error('Ocorreu um erro, tente novamente.', {
        timeout: 3000,
        closeOnClick: true
      });
    }
  },
  methods: {
    ...mapActions(["GetReportFields"]),
    ...mapGetters(["isAuthenticated"]),
    ...mapActions(["GetReport"]),
    ...mapActions(["UpdateReport"]),
    backReport() {
      this.$router.push('/report');
    },
    async showModalReportFinished() {
      this.saveChanges();
      this.typeSteps = "review"
      this.$refs.modalLoadingSignature.show();
      this.isModalLoadingSignature = true;
      this.showEditOption = false;
    },
    closeModalLoadingSignature() {
      this.isModalLoadingSignature = false;
    },
    saveChanges() {
      const reportUpdate = {
        id: this.Report.id,
        info: {
          ...{finished: 1},
        }
      }
      this.UpdateReport(reportUpdate);
    },
    showModalTriage(report) {
      this.protocolInfo = report.protocol_update_info;
      this.isModalTriageVisible = true;
    },
    closeModalTriage() {
      this.isModalTriageVisible = false;
    },
    formatName(name) {
      let words = name.toLowerCase().split(" ");
      for (let i = 0; i < words.length; i++) {
        let word = words[i];
        words[i] = word.charAt(0).toUpperCase() + word.slice(1);
      }
      return words.join(" ");
    },
    formatRamsay(number) {
      return "Ramsay " + number
    }
  },
};
</script>

<style>
.button-back {
  background-color: #ffff;
  border: none;
}

.loading {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

</style>